import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../Component/Common/Table";
import Pagination from "../../Component/Common/Pagination";
import {
  deleteCoupon,
  getCoupons,
  selectEditCoupon,
  toggleCouponStatus,
} from "../../store/coupon/coupon.action";
import Button from "../../Component/Common/Button";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/EditBtn.svg";
import { warning } from "../../util/Alert";
import ToggleSwitch from "../../Component/Common/ToggleSwitch";
import dayjs from "dayjs";

const Coupons = ({ changeTab }) => {
  const dispatch = useDispatch();
  const { coupons, totalCoupons } = useSelector((state) => state.coupon);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleDeleteCoupon = (plan) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            dispatch(deleteCoupon(plan._id));
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const couponDataMap = [
    {
      Header: "Code",
      Cell: ({ row }) => (
        <p className="mb-0 fw-semibold text-capitalize">{row.code}</p>
      ),
    },
    {
      Header: "Description",
      Cell: ({ row }) => (
        <p className="mb-0" style={{ maxWidth: "200px" }}>
          {row.description}
        </p>
      ),
    },
    {
      Header: "Discount Type",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">{row.discountType}</p>
      ),
    },
    {
      Header: "Discount Value",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">{row.discountValue}</p>
      ),
    },
    {
      Header: "Max Discount Amount",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">{row.maxDiscountAmount || "-"}</p>
      ),
    },
    {
      Header: "Used",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">{row.usageCount}</p>
      ),
    },
    {
      Header: "Usage Limit",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">
          {row.usageLimit ? row.usageLimit : "Unlimited"}
        </p>
      ),
    },
    {
      Header: "Per Tenant Limit",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">{row.perTenantLimit}</p>
      ),
    },
    {
      Header: "Applicable Plans",
      Cell: ({ row }) =>
        row.plansDetails.length > 0
          ? row.plansDetails.map((plan) => (
              <p className="mb-0 text-capitalize">
                {plan.name}({plan.billingCycle})
              </p>
            ))
          : "All",
    },
    {
      Header: "Valid From",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">
          {dayjs(row.validFrom).format("DD MMM YYYY")}
        </p>
      ),
    },
    {
      Header: "Valid Until",
      Cell: ({ row }) => (
        <p className="mb-0 text-capitalize">
          {row.validUntil ? dayjs(row.validUntil).format("DD MMM YYYY") : "-"}
        </p>
      ),
    },
    {
      Header: "Active",
      Cell: ({ row }) => (
        <ToggleSwitch
          checked={row?.isActive}
          onChange={() => dispatch(toggleCouponStatus(row._id))}
        />
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center gap-2">
          <Button
            className="icon-btn"
            startIcon={<EditIcon />}
            onClick={() => {
              dispatch(selectEditCoupon(row));
              changeTab();
            }}
          />
          <Button
            className="icon-btn"
            startIcon={<TrashIcon />}
            onClick={() => handleDeleteCoupon(row)}
          />
        </div>
      ),
    },
  ];

  const fetchCoupons = () => {
    dispatch(getCoupons(page - 1, size));
  };

  useEffect(() => {
    fetchCoupons();
  }, [page, size]);

  return (
    <div>
      <Table
        data={coupons}
        mapData={couponDataMap}
        noDataMessage={"No Coupon Found!"}
      />

      <div className="mt-3">
        <Pagination
          totalItem={totalCoupons}
          activePage={page}
          pageSize={size}
          onActivePageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPage}
        />
      </div>
    </div>
  );
};

export default Coupons;
